//export const server = 'dev';
export const server = 'bookings';

